<template>
  <div>
    <v-layout row wrap justify-center>
      <ui-title-red textTitle="Calculadora de patrimonio"></ui-title-red>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc  :vidTittle="'Pasivos'" videoEmbed="ADMINISTRACIONDINERO52Pasivos.mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 mt-4>
        <p>
          Ahora debe calcular el valor  de sus pasivos. La calculadora automáticamente arrojará al final de la
          tabla el valor de su patrimonio basado en los datos que usted ingresó.
          <br><br>
          Importante: Digite las cifras sin puntos ni comas

        </p>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <ui-calculadora-patri
      :formulario="patrimonioPasivo"
      nombresCols="Pasivos"
      ></ui-calculadora-patri>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    patrimonioPasivo() {
      return this.$store.state.patrimonioPasivo;
    }
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-52.vue?b395aea8